import elt from '../../../html/elt';
import logging from '../../../logging';

const log = logging('components');

export default class DropdownInput extends HTMLElement {

    private select: HTMLSelectElement;
    private _value: string;

    constructor() {
        super();
        this.select = elt('select', {class: 'form-select'});
    }

    connectedCallback() {
        log.debug('DropdownInput.init()');
        const options = this.querySelectorAll('option');
        this.select.append(...options);
        this.select.value = this._value;
        this.select.addEventListener(
            'change', () => this.value = this.select.value);
        this.append(this.select);
    }

    get value(): string {
        return this._value;
    }

    set value(value: string) {
        log.debug('DropdownInput set value');
        if(value != this._value) {
            if(this.select) this.select.value = value;
            this._value = value;
            //this.dispatchEvent(new CustomEvent('change'));
        }
    }
}
window.customElements.define('dropdown-input', DropdownInput);
log.debug('Defined custom element <dropdown-input>');
